import { Icon } from "@chakra-ui/react"

export const HtmlIcon = (props: any) => (
  <Icon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 93.66 104.93">
    <g id="Group_1664" transform="translate(0)">
      <g id="group-54svg" transform="translate(0)">
        <path id="path-1_50_" d="M82.75,81.24c0,6.86-5.56,12.42-12.42,12.43c0,0,0,0,0,0H23.24c-6.86,0-12.42-5.56-12.43-12.42
          c0,0,0,0,0,0V23.69c0-6.86,5.56-12.43,12.43-12.43h47.08c6.86,0,12.42,5.56,12.43,12.42c0,0,0,0,0,0V81.24z M78.83,23.69
          c0-4.7-3.81-8.5-8.5-8.5l0,0H23.24c-4.7,0-8.5,3.81-8.5,8.5c0,0,0,0,0,0v57.54c0,4.7,3.81,8.5,8.5,8.5h47.08
          c4.7,0,8.5-3.81,8.5-8.5v0V23.69z"/>
        <path id="path-2_50_" d="M16.8,37.42h-2.62c-1.08,0-1.96-0.88-1.96-1.96c0-1.08,0.88-1.96,1.96-1.96h2.62
          c1.08,0,1.96,0.88,1.96,1.96C18.76,36.55,17.88,37.42,16.8,37.42z"/>
        <path id="path-3_49_" d="M78.27,37.42H16.8c-1.08,0-1.96-0.88-1.96-1.96c0-1.08,0.88-1.96,1.96-1.96h61.47
          c1.08,0,1.96,0.88,1.96,1.96C80.23,36.54,79.35,37.42,78.27,37.42C78.27,37.42,78.27,37.42,78.27,37.42z"/>
        <path id="path-4_33_" d="M80.88,37.42h-2.62c-1.08,0-1.96-0.88-1.96-1.96c0-1.08,0.88-1.96,1.96-1.96h2.62
          c1.08,0,1.96,0.88,1.96,1.96C82.84,36.55,81.97,37.42,80.88,37.42z"/>
        <path id="path-5_21_" d="M32.79,25.85c0,1.85-1.5,3.34-3.34,3.34c-1.85,0-3.34-1.5-3.34-3.34c0-1.84,1.49-3.34,3.34-3.34
          C31.3,22.5,32.79,24,32.79,25.85C32.79,25.84,32.79,25.85,32.79,25.85z"/>
        <path id="path-6_10_" d="M44.83,25.85c0,1.85-1.5,3.34-3.34,3.34c-1.85,0-3.34-1.5-3.34-3.34c0-1.84,1.49-3.34,3.34-3.34
          C43.33,22.5,44.83,24,44.83,25.85z"/>
        <path id="path-7_8_" d="M55.52,25.85c0,1.85-1.49,3.34-3.34,3.35c-1.85,0-3.34-1.49-3.35-3.34c0-1.85,1.49-3.34,3.34-3.35
          c0,0,0,0,0,0C54.03,22.5,55.52,24,55.52,25.85C55.52,25.84,55.52,25.85,55.52,25.85z"/>
        <path id="path-8_4_" d="M59.83,70.68c-1.08,0-1.96-0.88-1.96-1.96c0-0.65,0.32-1.26,0.86-1.62l10.01-6.81l-9.79-5.01
          c-0.95-0.51-1.31-1.7-0.8-2.66c0.5-0.93,1.64-1.3,2.58-0.84l10.12,5.17c1.82,0.93,2.54,3.16,1.61,4.99
          c-0.26,0.51-0.64,0.96-1.11,1.3l-10.42,7.09C60.62,70.56,60.23,70.68,59.83,70.68z"/>
        <path id="path-9_1_" d="M37.34,75.91c-0.39,0-0.78-0.12-1.1-0.34l-10.36-7.06c-1.67-1.18-2.07-3.49-0.89-5.16
          c0.35-0.49,0.81-0.89,1.35-1.17l10.12-5.17c0.98-0.47,2.15-0.07,2.62,0.91c0.46,0.95,0.09,2.09-0.84,2.58l-9.79,5.01l10.01,6.81
          c0.9,0.61,1.13,1.83,0.51,2.73c-0.37,0.54-0.97,0.86-1.62,0.86L37.34,75.91z"/>
        <path id="path-10" d="M44.83,79.69c-0.2,0-0.39-0.03-0.58-0.09c-1.03-0.32-1.61-1.42-1.29-2.45c0,0,0,0,0,0l8.6-27.61
          c0.32-1.03,1.42-1.61,2.46-1.29c1.03,0.32,1.61,1.42,1.29,2.46l-8.6,27.61C46.44,79.13,45.68,79.69,44.83,79.69z"/>
      </g>
    </g>
  </Icon>
);
